<template>
    <v-container>
        <v-row>
            <v-col v-for="(type, index) in fileTypes"
                   :key="index"
                   cols="auto">
                <v-checkbox :label="type"
                            :value="type"
                            v-model="selectedTypes"
                            @change="updateParent" />
            </v-col>
            <v-col>
                <v-text-field style="width: 160px; float: left;" :label="$t('limitFileSize')"
                              type="number"
                              v-model.number="fileSizeLimit"
                              @input="updateParent" />
            </v-col>
            <v-col>
                <v-text-field style="width: 160px; float: left;" :label="$t('MaxNbFiles')"
                              type="number"
                              v-model.number="maxFiles"
                              @input="updateParent" />
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <div>{{ $t('fileSizeLimit')}}{{ fileSizeLimit }} MB</div>
                <div>{{$t('maxNumberFile')}}{{ maxFiles }}</div>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    export default {
        props: {
            value: {
                type: String,
                default: ''
            },
            initialSizeLimit: {
                type: Number,
                default: 2 // in MB
            },
            initialMaxFiles: {
                type: Number,
                default: 10 // max number of files
            }
        },
        data() {
            return {
                fileTypes: ['pdf', 'doc', 'docx', 'png', 'jpg', 'jpeg', 'gif'],
                selectedTypes: this.value ? this.value.split('#')[0].split(',').filter(Boolean).map(type => type.replace('.', '')) : [],
                fileSizeLimit: this.value.split('#')[1] || this.initialSizeLimit, 
                maxFiles: this.value.split('#')[2] || this.initialMaxFiles 
            }
        },
        methods: {
            updateParent() {
                const formattedTypes = this.selectedTypes
                    .map(type => `.${type}`)
                    .filter(type => type !== '.')
                    .join(',')

                const combinedValue = `${formattedTypes}#${this.fileSizeLimit}#${this.maxFiles}`

                this.$emit('input', combinedValue)
            },
            updateSizeLimit() {
                this.$emit('size-limit-change', this.fileSizeLimit)
            }
        },
        watch: {
            value(newVal) {
                const [types = '', sizeLimit = this.initialSizeLimit, maxFiles = this.initialMaxFiles] = newVal.split('#')
                this.selectedTypes = types ? types.split('#')[0].split(',').filter(Boolean).map(type => type.replace('.', '')) : []
                this.fileSizeLimit = Number(sizeLimit) || this.initialSizeLimit
                this.maxFiles = Number(maxFiles) || this.initialMaxFiles
            }
        }
    }
</script>
